import { Outlet } from "react-router-dom";

const ProjectPageLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default ProjectPageLayout;